import { Box } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import OverflowChipTooltip from "components/Tooltips/OverflowChipTooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { OLButton } from "OLButton";
import { KeyValuePair } from "utilities/objects";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    labels: {
      alignItems: "center",
      display: "flex",
      flexWrap: "nowrap",
      gap: theme.spacing(4),
    },
    showAllBtn: {
      height: "32px",
      padding: theme.spacing(0, 4),
      fontSize: "13px",
      fontWeight: 500,
      lineHeight: "22px",
      textDecoration: "underline",
      "&:hover": {
        textDecoration: "underline",
      },
    },
    chipWrapper: {
      maxWidth: "130px",
    },
  }),
);

interface OverflowChipsCellProps {
  labels: KeyValuePair[];
  openCustomAttributesModal: () => void;
  setCustomAttributes: React.Dispatch<
    React.SetStateAction<KeyValuePair[] | undefined>
  >;
  "data-test-id"?: string;
}

export function OverflowChipsCell({
  labels,
  openCustomAttributesModal,
  setCustomAttributes,
  "data-test-id": dataTestId,
}: OverflowChipsCellProps) {
  const classes = useStyles();
  const { message } = useMessage();

  return labels.length > 2 ? (
    <Box className={classes.labels}>
      {labels.slice(0, 2).map((label, index) => (
        <Box className={classes.chipWrapper} key={index}>
          <OverflowChipTooltip
            placement="top"
            label={`${label.key}: ${label.value}`}
            data-test-id={dataTestId && `${dataTestId}-${index}`}
          />
        </Box>
      ))}
      <OLButton
        className={classes.showAllBtn}
        onClick={() => {
          setCustomAttributes(labels);
          openCustomAttributesModal();
        }}
      >
        {message({ id: "showAllElements" }, { elements: labels.length })}
      </OLButton>
    </Box>
  ) : (
    <Box className={classes.labels}>
      {labels.map((label, index) => (
        <Box className={classes.chipWrapper} key={index}>
          <OverflowChipTooltip
            placement="top"
            label={`${label.key}: ${label.value}`}
            data-test-id={dataTestId && `${dataTestId}-${index}`}
          />
        </Box>
      ))}
    </Box>
  );
}
